import React, { FC, HTMLAttributes, useEffect } from "react";
import styled from "styled-components";

const Popup: FC<HTMLAttributes<HTMLDivElement> & { opened: boolean; onClose: () => void }> = ({ opened, onClose, children, ...props }) => {
  useEffect(() => {
    document.body.style.overflow = opened ? "hidden" : "";
  }, [opened]);
  return (
    <Root onClick={onClose}>
      <Box {...props}>{children}</Box>
    </Root>
  );
};
export default Popup;

const Root = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1300;
`;
const Box = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: auto;
`;
